/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const badges = {
  deal: 'HOT',
  nextDayDelivery: 'Free Next Day Delivery',
};
